import { useEffect, useState } from "react";

export const useIsSticky = (element: Element | string) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      let targetElement: Element | null = null;

      if (typeof element === "string") {
        targetElement = document.querySelector(element);
      } else {
        targetElement = element;
      }

      if (!targetElement) return;

      const stickyElementStyle = window.getComputedStyle(targetElement);

      const stickyElementTop = parseInt(stickyElementStyle.top, 10);
      const top = targetElement!.getBoundingClientRect().top;

      setIsSticky(top <= stickyElementTop);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [element, isSticky]);

  return isSticky;
};
